// This file contains Protobuf definitions used to implement Three Domain Secure (3DS) and
// Strong Customer Authentication (SCA) support in Checkout APIs.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file common/v1/three_domain_secure.proto (package common.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { BoolValue, Int32Value } from "../../google/protobuf/wrappers_pb";

/**
 * Supported challenge window dimensions for SCA.
 *
 * @generated from enum common.v1.ScaChallengeWindowSize
 */
export const ScaChallengeWindowSize = proto3.makeEnum(
  "common.v1.ScaChallengeWindowSize",
  [
    {no: 0, name: "SCA_CHALLENGE_WINDOW_SIZE_UNSPECIFIED"},
    {no: 1, name: "SCA_CHALLENGE_WINDOW_SIZE_250_X_400"},
    {no: 2, name: "SCA_CHALLENGE_WINDOW_SIZE_390_X_400"},
    {no: 3, name: "SCA_CHALLENGE_WINDOW_SIZE_500_X_600"},
    {no: 4, name: "SCA_CHALLENGE_WINDOW_SIZE_600_X_400"},
    {no: 5, name: "SCA_CHALLENGE_WINDOW_SIZE_FULL_SCREEN"},
  ],
);

/**
 * BrowserInfo models Shopper's web browser data which are used to implement the 3DS Challenge UI.
 * This message is used by Pay API in case if the Shopper decides to use a payment card as the
 * payment method.
 *
 * @generated from message common.v1.BrowserInfo
 */
export const BrowserInfo = proto3.makeMessageType(
  "common.v1.BrowserInfo",
  () => [
    { no: 1, name: "accept_header", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "language", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "color_depth", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "screen_height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "screen_width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "timezone_offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * PaymentCardScaRequest models SCA request data which will be sent to 3DS provider if the
 * Shopper is using a payment card as a payment method.
 * This message is used by SetupCheckoutIntent API and must be populated if the Merchant wants
 * (or must) use SCA for payment card transactions.
 * Any change on PaymentCardScaRequest must be backward compatible
 *
 * @generated from message common.v1.PaymentCardScaRequest
 */
export const PaymentCardScaRequest = proto3.makeMessageType(
  "common.v1.PaymentCardScaRequest",
  () => [
    { no: 6, name: "exemption", jsonName: "SCAExemptionReason", kind: "enum", T: proto3.getEnumType(PaymentCardScaRequest_ScaExemption) },
    { no: 1, name: "challenge_type", jsonName: "threeDSChallengeType", kind: "enum", T: proto3.getEnumType(PaymentCardScaRequest_ChallengeType) },
    { no: 2, name: "cardholder_account_history", kind: "message", T: CardholderAccountHistory },
    { no: 3, name: "purchase_info", kind: "message", T: PurchaseInfo },
    { no: 4, name: "requestor_authentication_info", kind: "message", T: RequestorAuthenticationInfo },
    { no: 5, name: "requestor_prior_transaction_authentication_info", kind: "message", T: RequestorPriorTransactionAuthenticationInfo },
    { no: 7, name: "authentication_type", kind: "enum", T: proto3.getEnumType(PaymentCardScaRequest_AuthenticationType) },
  ],
);

/**
 * Types of exemptions which could be requested by merchant.
 *
 * @generated from enum common.v1.PaymentCardScaRequest.ScaExemption
 */
export const PaymentCardScaRequest_ScaExemption = proto3.makeEnum(
  "common.v1.PaymentCardScaRequest.ScaExemption",
  [
    {no: 0, name: "SCA_EXEMPTION_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SCA_EXEMPTION_TRUSTED_MERCHANT", localName: "TRUSTED_MERCHANT"},
    {no: 2, name: "SCA_EXEMPTION_SECURE_CORPORATE_PAYMENT", localName: "SECURE_CORPORATE_PAYMENT"},
    {no: 3, name: "SCA_EXEMPTION_TRANSACTION_RISK_ANALYSIS", localName: "TRANSACTION_RISK_ANALYSIS"},
    {no: 4, name: "SCA_EXEMPTION_LOW_VALUE_PAYMENT", localName: "LOW_VALUE_PAYMENT"},
    {no: 5, name: "SCA_EXEMPTION_MERCHANT_INITIATED_TRANSACTION", localName: "MERCHANT_INITIATED_TRANSACTION"},
    {no: 6, name: "SCA_EXEMPTION_RECURRING_PAYMENT", localName: "RECURRING_PAYMENT"},
    {no: 7, name: "SCA_EXEMPTION_DELEGATION", localName: "DELEGATION"},
  ],
);

/**
 * Challenges that could be requested for transactions.
 *
 * @generated from enum common.v1.PaymentCardScaRequest.ChallengeType
 */
export const PaymentCardScaRequest_ChallengeType = proto3.makeEnum(
  "common.v1.PaymentCardScaRequest.ChallengeType",
  [
    {no: 0, name: "CHALLENGE_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "CHALLENGE_TYPE_NO_PREFERENCE", localName: "NO_PREFERENCE"},
    {no: 2, name: "CHALLENGE_TYPE_NO_CHALLENGE_REQUESTED", localName: "NO_CHALLENGE_REQUESTED"},
    {no: 3, name: "CHALLENGE_TYPE_CHALLENGE_REQUESTED", localName: "CHALLENGE_REQUESTED"},
    {no: 4, name: "CHALLENGE_TYPE_CHALLENGE_MANDATED", localName: "CHALLENGE_MANDATED"},
    {no: 5, name: "CHALLENGE_TYPE_NO_CHALLENGE_TRANSACTION_RISK_ANALYZED", localName: "NO_CHALLENGE_TRANSACTION_RISK_ANALYZED"},
    {no: 6, name: "CHALLENGE_TYPE_NO_CHALLENGE_DATA_SHARE_ONLY", localName: "NO_CHALLENGE_DATA_SHARE_ONLY"},
    {no: 7, name: "CHALLENGE_TYPE_NO_CHALLENGE_SCA_ALREADY_COMPLETED", localName: "NO_CHALLENGE_SCA_ALREADY_COMPLETED"},
    {no: 8, name: "CHALLENGE_TYPE_NO_CHALLENGE_TRUSTED", localName: "NO_CHALLENGE_TRUSTED"},
  ],
);

/**
 * Indicates the type of cardholder Authentication request requested by the
 * authentication requestor (JPMC managed SCA merchants)
 *
 * @generated from enum common.v1.PaymentCardScaRequest.AuthenticationType
 */
export const PaymentCardScaRequest_AuthenticationType = proto3.makeEnum(
  "common.v1.PaymentCardScaRequest.AuthenticationType",
  [
    {no: 0, name: "AUTHENTICATION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AUTHENTICATION_TYPE_DEFAULT", localName: "DEFAULT"},
    {no: 2, name: "AUTHENTICATION_TYPE_EXEMPTION", localName: "EXEMPTION"},
    {no: 3, name: "AUTHENTICATION_TYPE_AUTHENTICATION", localName: "AUTHENTICATION"},
  ],
);

/**
 * CardholderAccountHistory models additional information about the Cardholder’s Account provided
 * by the 3DS Requestor.
 * This data are used to increase a chance of skipping the authentication.
 *
 * @generated from message common.v1.CardholderAccountHistory
 */
export const CardholderAccountHistory = proto3.makeMessageType(
  "common.v1.CardholderAccountHistory",
  () => [
    { no: 1, name: "account_created_at", jsonName: "accountCreateTimestamp", kind: "message", T: Timestamp },
    { no: 2, name: "account_updated_at", jsonName: "accountUpdateTimestamp", kind: "message", T: Timestamp },
    { no: 4, name: "payment_card_used_first_time_at", jsonName: "cardFirstUsedDate", kind: "message", T: Timestamp },
    { no: 5, name: "last_24_hours_add_card_attempts", jsonName: "consumerAccount24HoursAddCardCount", kind: "message", T: Int32Value },
    { no: 6, name: "password_updated_at", jsonName: "consumerAccountPasswordUpdateTimestamp", kind: "message", T: Timestamp },
    { no: 7, name: "last_24_hours_transaction_count", kind: "message", T: Int32Value },
    { no: 8, name: "last_year_transaction_count", kind: "message", T: Int32Value },
    { no: 9, name: "last_6_months_purchase_count", kind: "message", T: Int32Value },
    { no: 10, name: "past_suspicious_activity", jsonName: "consumerAccountSuspiciousActivityIndicator", kind: "message", T: BoolValue },
    { no: 11, name: "billing_address_matches_shipping_address", jsonName: "consumerAccountAddressIdenticalIndicator", kind: "message", T: BoolValue },
    { no: 12, name: "shipping_address_first_used_at", jsonName: "consumerShippingAddressFirstUsageDate", kind: "message", T: Timestamp },
    { no: 13, name: "cardholder_name_matches_recipient_name", jsonName: "consumerShipToNameIdenticalIndicator", kind: "message", T: BoolValue },
  ],
);

/**
 * Purchase information which is used to increase a chance of skipping the authentication.
 *
 * @generated from message common.v1.PurchaseInfo
 */
export const PurchaseInfo = proto3.makeMessageType(
  "common.v1.PurchaseInfo",
  () => [
    { no: 1, name: "purchase_date", jsonName: "lastPurchaseDate", kind: "message", T: Timestamp },
    { no: 2, name: "recurring_frequency", jsonName: "paymentFrequency", kind: "message", T: Int32Value },
    { no: 3, name: "merchant_fraud_risk_assessment", kind: "message", T: PurchaseInfo_MerchantFraudRiskAssessment },
    { no: 4, name: "transaction_type", kind: "enum", T: proto3.getEnumType(PurchaseInfo_TransactionType) },
    { no: 5, name: "purchased_item_count", kind: "scalar", T: 13 /* ScalarType.UINT32 */, opt: true },
  ],
);

/**
 * Defines types of transaction from 3DS authentication perspective.
 * UPG claims that these values are derived from ISO 8583, though I didn't find any
 * documentation about how it was done.
 *
 * @generated from enum common.v1.PurchaseInfo.TransactionType
 */
export const PurchaseInfo_TransactionType = proto3.makeEnum(
  "common.v1.PurchaseInfo.TransactionType",
  [
    {no: 0, name: "TRANSACTION_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "TRANSACTION_TYPE_CHECK", localName: "CHECK"},
    {no: 2, name: "TRANSACTION_TYPE_GOODS_SERVICES", localName: "GOODS_SERVICES"},
    {no: 3, name: "TRANSACTION_TYPE_ACCOUNT_FUNDING", localName: "ACCOUNT_FUNDING"},
    {no: 4, name: "TRANSACTION_TYPE_QUASI_CASH", localName: "QUASI_CASH"},
    {no: 5, name: "TRANSACTION_TYPE_PREPAID", localName: "PREPAID"},
  ],
);

/**
 * Merchant's assessment of the level of fraud risk for the specific authentication for both
 * the Cardholder and the authentication being conducted.
 *
 * @generated from message common.v1.PurchaseInfo.MerchantFraudRiskAssessment
 */
export const PurchaseInfo_MerchantFraudRiskAssessment = proto3.makeMessageType(
  "common.v1.PurchaseInfo.MerchantFraudRiskAssessment",
  () => [
    { no: 1, name: "shipping_method", jsonName: "shipmentType", kind: "enum", T: proto3.getEnumType(PurchaseInfo_MerchantFraudRiskAssessment_ShippingMethod) },
    { no: 2, name: "delivery_type", jsonName: "deliveryTimeframe", kind: "enum", T: proto3.getEnumType(PurchaseInfo_MerchantFraudRiskAssessment_DeliveryType) },
    { no: 3, name: "delivery_email_address", jsonName: "orderEmailAddress", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "reorder_purchase", jsonName: "productRepurchase", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 5, name: "preorder_purchase", jsonName: "productPreorder", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "preorder_availability_date", kind: "message", T: Timestamp },
    { no: 7, name: "estimated_fraud_risk_score", jsonName: "requestorEstimatedTransactionFraudRiskScore", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
  {localName: "PurchaseInfo_MerchantFraudRiskAssessment"},
);

/**
 * Defines shipping methods which can be used for the transaction.
 *
 * @generated from enum common.v1.PurchaseInfo.MerchantFraudRiskAssessment.ShippingMethod
 */
export const PurchaseInfo_MerchantFraudRiskAssessment_ShippingMethod = proto3.makeEnum(
  "common.v1.PurchaseInfo.MerchantFraudRiskAssessment.ShippingMethod",
  [
    {no: 0, name: "SHIPPING_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "SHIPPING_METHOD_SHIP_TO_BILLING_ADDRESS", localName: "SHIP_TO_BILLING_ADDRESS"},
    {no: 2, name: "SHIPPING_METHOD_SHIP_TO_VERIFIED_ADDRESS_ON_FILE", localName: "SHIP_TO_VERIFIED_ADDRESS_ON_FILE"},
    {no: 3, name: "SHIPPING_METHOD_SHIP_TO_ADDRESS_NOT_ON_FILE", localName: "SHIP_TO_ADDRESS_NOT_ON_FILE"},
    {no: 4, name: "SHIPPING_METHOD_SHIP_TO_STORE_FOR_PICKUP", localName: "SHIP_TO_STORE_FOR_PICKUP"},
    {no: 5, name: "SHIPPING_METHOD_DIGITAL_GOODS_DELIVERY", localName: "DIGITAL_GOODS_DELIVERY"},
    {no: 6, name: "SHIPPING_METHOD_TICKETS", localName: "TICKETS"},
    {no: 7, name: "SHIPPING_METHOD_OTHER", localName: "OTHER"},
  ],
);

/**
 * Defines the merchandise delivery timeframes.
 *
 * @generated from enum common.v1.PurchaseInfo.MerchantFraudRiskAssessment.DeliveryType
 */
export const PurchaseInfo_MerchantFraudRiskAssessment_DeliveryType = proto3.makeEnum(
  "common.v1.PurchaseInfo.MerchantFraudRiskAssessment.DeliveryType",
  [
    {no: 0, name: "DELIVERY_TYPE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "DELIVERY_TYPE_ELECTRONIC_DELIVERY", localName: "ELECTRONIC_DELIVERY"},
    {no: 2, name: "DELIVERY_TYPE_SAME_DAY_SHIPPING", localName: "SAME_DAY_SHIPPING"},
    {no: 3, name: "DELIVERY_TYPE_OVERNIGHT_SHIPPING", localName: "OVERNIGHT_SHIPPING"},
    {no: 4, name: "DELIVERY_TYPE_TWO_DAYS_OR_MORE_SHIPPING", localName: "TWO_DAYS_OR_MORE_SHIPPING"},
  ],
);

/**
 * How the 3DS Requestor authenticated the Cardholder before or during the transaction.
 * This data are used to increase a chance of skipping the authentication.
 *
 * @generated from message common.v1.RequestorAuthenticationInfo
 */
export const RequestorAuthenticationInfo = proto3.makeMessageType(
  "common.v1.RequestorAuthenticationInfo",
  () => [
    { no: 1, name: "requestor_authentication_method", kind: "enum", T: proto3.getEnumType(RequestorAuthenticationInfo_RequestorAuthenticationMethod) },
    { no: 2, name: "authenticated_at", jsonName: "threeDSAuthenticationTimestamp", kind: "message", T: Timestamp },
    { no: 3, name: "authentication_data", jsonName: "threeDSAuthenticationData", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "authentication_use_case", kind: "enum", T: proto3.getEnumType(RequestorAuthenticationInfo_AuthenticationUseCase) },
  ],
);

/**
 * Methods used by the Cardholder to authenticate to the 3DS Requestor.
 *
 * @generated from enum common.v1.RequestorAuthenticationInfo.RequestorAuthenticationMethod
 */
export const RequestorAuthenticationInfo_RequestorAuthenticationMethod = proto3.makeEnum(
  "common.v1.RequestorAuthenticationInfo.RequestorAuthenticationMethod",
  [
    {no: 0, name: "REQUESTOR_AUTHENTICATION_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "REQUESTOR_AUTHENTICATION_METHOD_NONE", localName: "NONE"},
    {no: 2, name: "REQUESTOR_AUTHENTICATION_METHOD_REQUESTOR_CRED", localName: "REQUESTOR_CRED"},
    {no: 3, name: "REQUESTOR_AUTHENTICATION_METHOD_FEDERATED_ID", localName: "FEDERATED_ID"},
    {no: 4, name: "REQUESTOR_AUTHENTICATION_METHOD_ISSUER_CRED", localName: "ISSUER_CRED"},
    {no: 5, name: "REQUESTOR_AUTHENTICATION_METHOD_FIDO_AUTHENTICATOR", localName: "FIDO_AUTHENTICATOR"},
  ],
);

/**
 * @generated from enum common.v1.RequestorAuthenticationInfo.AuthenticationUseCase
 */
export const RequestorAuthenticationInfo_AuthenticationUseCase = proto3.makeEnum(
  "common.v1.RequestorAuthenticationInfo.AuthenticationUseCase",
  [
    {no: 0, name: "AUTHENTICATION_USE_CASE_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "AUTHENTICATION_USE_CASE_SINGLE_PAYMENT", localName: "SINGLE_PAYMENT"},
    {no: 2, name: "AUTHENTICATION_USE_CASE_RECURRING_PAYMENT_FIXED", localName: "RECURRING_PAYMENT_FIXED"},
    {no: 3, name: "AUTHENTICATION_USE_CASE_INSTALLMENT_PAYMENT", localName: "INSTALLMENT_PAYMENT"},
    {no: 4, name: "AUTHENTICATION_USE_CASE_PAYMENT_ON_SHIPMENT", localName: "PAYMENT_ON_SHIPMENT"},
    {no: 5, name: "AUTHENTICATION_USE_CASE_RECURRING_PAYMENT_OTHER", localName: "RECURRING_PAYMENT_OTHER"},
    {no: 6, name: "AUTHENTICATION_USE_CASE_PREAUTHORIZATION_RENTAL", localName: "PREAUTHORIZATION_RENTAL"},
    {no: 7, name: "AUTHENTICATION_USE_CASE_PREAUTHORIZATION_NO_RENTAL", localName: "PREAUTHORIZATION_NO_RENTAL"},
  ],
);

/**
 * Information about how the 3DS Requestor authenticated the cardholder as part of a previous
 * 3DS transaction.
 * This data are used to increase a chance of skipping the authentication.
 *
 * @generated from message common.v1.RequestorPriorTransactionAuthenticationInfo
 */
export const RequestorPriorTransactionAuthenticationInfo = proto3.makeMessageType(
  "common.v1.RequestorPriorTransactionAuthenticationInfo",
  () => [
    { no: 1, name: "prior_acs_transaction_id", jsonName: "acsTransactionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "prior_authentication_method", jsonName: "requestorAuthenticationMethod", kind: "enum", T: proto3.getEnumType(RequestorPriorTransactionAuthenticationInfo_PriorAuthenticationMethod) },
    { no: 3, name: "prior_authentication_at", jsonName: "threeDSAuthenticationTimestamp", kind: "message", T: Timestamp },
    { no: 4, name: "prior_authentication_data", jsonName: "threeDSAuthenticationData", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * Mechanism used by the Cardholder to previously authenticate to the 3DS Requestor.
 *
 * @generated from enum common.v1.RequestorPriorTransactionAuthenticationInfo.PriorAuthenticationMethod
 */
export const RequestorPriorTransactionAuthenticationInfo_PriorAuthenticationMethod = proto3.makeEnum(
  "common.v1.RequestorPriorTransactionAuthenticationInfo.PriorAuthenticationMethod",
  [
    {no: 0, name: "PRIOR_AUTHENTICATION_METHOD_UNSPECIFIED", localName: "UNSPECIFIED"},
    {no: 1, name: "PRIOR_AUTHENTICATION_METHOD_FRICTIONLESS_AUTHENTICATION_BY_ACS", localName: "FRICTIONLESS_AUTHENTICATION_BY_ACS"},
    {no: 2, name: "PRIOR_AUTHENTICATION_METHOD_CHALLENGED_BY_ACS", localName: "CHALLENGED_BY_ACS"},
    {no: 3, name: "PRIOR_AUTHENTICATION_METHOD_AVS_VERIFIED", localName: "AVS_VERIFIED"},
    {no: 4, name: "PRIOR_AUTHENTICATION_METHOD_OTHER_ISSUER_METHOD", localName: "OTHER_ISSUER_METHOD"},
  ],
);

/**
 * Details about SCA/3DS performed during Pay request.
 * The values of the fields below are populated straight from UPG response w/o any interpretation.
 * Please consult UPG 3DS docs for possible values and their meaning.
 * JSON values for these fields are specified   in https://jiradc-cib-cluster02.prod.aws.jpmchase.net/browse/MSCHECKOUT-6147
 *
 * @generated from message common.v1.ThreeDsTransactionDetails
 */
export const ThreeDsTransactionDetails = proto3.makeMessageType(
  "common.v1.ThreeDsTransactionDetails",
  () => [
    { no: 3, name: "status", jsonName: "threeDSTransactionStatus", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "challenge_method", jsonName: "challengeAuthenticationMethod", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "challenge_type", jsonName: "challengeAuthenticationType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "status_reason_text", jsonName: "authenticationStatusReasonText", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "authentication_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "three_ds_version", jsonName: "threeDSVersion", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "three_ds_authentication_timestamp", jsonName: "threeDSAuthenticationTimestamp", kind: "message", T: Timestamp },
    { no: 10, name: "three_ds_authentication_amount", jsonName: "threeDSAuthenticationAmount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 11, name: "three_ds_directory_server_transaction_id", jsonName: "threeDSDirectoryServerTransactionId", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "three_ds_authentication_method_code", jsonName: "threeDomainSecureAuthenticationMethodCode", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "three_ds_challenge_type", jsonName: "threeDSChallengeType", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "issuer_assigned_authentication_fraud_score", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "three_ds_secure_exemption", jsonName: "threeDomainSecureExemption", kind: "message", T: ThreeDomainSecureExemption },
  ],
);

/**
 * Details about SCA/3DS exemptions performed during Pay request.
 * The values of the fields below are populated straight from UPG response w/o any interpretation.
 * Please consult UPG 3DS docs for possible values and their meaning.
 *
 * @generated from message common.v1.ThreeDomainSecureExemption
 */
export const ThreeDomainSecureExemption = proto3.makeMessageType(
  "common.v1.ThreeDomainSecureExemption",
  () => [
    { no: 1, name: "authentication_exemption_reason", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "authentication_status_reason_text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

